import React from 'react'
import '../css/NotificationBadge.css'
import { useNotification } from './NotificationContext'

export const NotificationBadge = ({ id }) => {
  const { unreadMessages, userId } = useNotification()

  if (unreadMessages > 0) {
    return (
      <div className="notificationz">
        <span className="notify-badge">{unreadMessages}</span>
      </div>
    )
  }
  return null
}

export const NotificationByPlaceBadge = ({ count }) => {
  if (count > 0) {
    return (
      <div className="notificationz">
        <span className="notify-badge">{count}</span>
      </div>
    )
  }
  return null
}
